import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserGroupStore } from './userGroup.store';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { Group } from '@frontend-site/shared/data';

@Injectable({ providedIn: 'root' })
export class UserGroupsService {
    constructor(private readonly http: HttpClient, private readonly userGroupStore: UserGroupStore) {}

    loadUserGroups(companyId: number | undefined) {
        return this.loadUserGroupsFromServer(companyId).pipe(
            tap((groups: Group[]) => {
                this.userGroupStore.setGroups(groups.filter((group: Group) => group.status === 'ACTIVE'));
            })
        );
    }

    private loadUserGroupsFromServer(companyId: number | undefined): Observable<Group[]> {
        return this.http
            .get<Group[]>('/rest/userGroups/getList', {
                params: { companyId: companyId || 0 }
            })
            .pipe(
                catchError((err) => {
                    console.log('failed to get groups', err);
                    return throwError(err);
                })
            );
    }
}
